/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent: require('../../../../model/swiper/SwiperItem'),
    method: {
        init: function () {

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/banner/VideoItem.js
// module id = 526
// module chunks = 6